module.exports = __webpack_public_path__ + "static/img/model.feac7f3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/model.gif
// module id = hAIn
// module chunks = 1